<template>
  <div id="instagram-grid" class="section padding-top-bottom-big over-hide">
    <div class="contact-map" v-if="loading"></div>
    <div class="image-grid" v-else>
      <a
        :href="image.media_url"
        target="_blank"
        rel="noopener noreferrer"
        v-for="image in instagramImages"
        :key="image.id"
      >
        <img
          class="images"
          :id="'abc' + image.id"
          :src="image.media_url"
          :alt="image.caption"
        />
      </a>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <h5 class="mb-5">I am also on<br />Instagram</h5>
          <a
            href="https://www.instagram.com/shox_adomokai/"
            class="contact-link"
            target="_blank"
            >@shox_adomokai</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ScrollReveal from "scrollreveal";
export default {
  data() {
    return {
      loading: true,
      instagramImages: []
    };
  },
  methods: {
    getImages() {
      axios
        .get(
          "https://graph.instagram.com/me/media?fields=id,media_type,media_url,caption&count=2&access_token=IGQVJYSEhuLWthcnRiUW5ORHNLMFl0ai1TTXE0NDNFVllzbXpuSkNyTUNDWnVvLXBZAeUQxZAWRGNkxnTVdtUGZAIN2IyOVE5UUxXQTBpM1RKSTRPWjZAGQ0FKeG9GeUdIWWNWbE5kaDdnbE1VSmZALTllRdQZDZD"
        )
        .then(response => {
          var array = response.data.data.filter(
            response => response.media_type != "VIDEO"
          );
          this.instagramImages = array.slice(0, 15);
          this.loading = false;
          return array;
        })
        .then(array => {
          this.animateImages(array);
        })
        .catch(err => {
          console.log(err);
        });
    },
    animateImages(images) {
      for (let index in images) {
        ScrollReveal().reveal(`#abc${images[index].id}`, {
          duration: 800,
          reset: true,
          distance: "200px",
          delay: index * 50,
          afterReveal: function(el) {
            el.style.opacity = 0.2;
          }
        });
      }
    }
  },
  mounted() {
    this.getImages();
  }
};
</script>

<style lang="scss" scoped>
.contact-map {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background: red;
  background-image: url(../assets/img/map.jpg);
}

.image-grid {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-wrap: wrap;
  transition: 0.5s all ease;

  a {
    display: block;
    position: relative;
    width: 20%;
    max-height: 50%;
    flex-grow: 1;
  }
}

.images {
  width: 100%;
  height: 100%;
  border: solid 2px black;
  object-fit: cover;
  object-position: top;
  filter: grayscale(100);
  opacity: 1;

  &:hover {
    filter: grayscale(0);
    opacity: 1 !important;
    transition: 0.3s all ease !important;
  }
}

.contact-link {
  font-size: 15px;
  line-height: 1.7;
  letter-spacing: 2px;
  font-weight: 400;
  color: #c4c3ca;
  transition: all 250ms linear;
}
.contact-link:hover {
  text-decoration: none;
  color: $primary;
}
</style>
